import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';

import { cicChangePropTypes } from '../../LoanCicHistory.propTypes';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';

import { listStyles } from './CicEditHistoryList.styles';
import { buildEditHistoryEntries } from './CicEditHistoryList.utils';
import CicEditHistoryEntry from './components/CicEditHistoryEntry';

const CicEditHistoryList = ({ change }) => {
  const entries = useMemo(() => buildEditHistoryEntries(change), [change]);

  return (
    <Box data-testid={LoanCicHistoryTestIds.EDIT_HISTORY_LIST} sx={listStyles}>
      {entries.map(entry => (
        <CicEditHistoryEntry entry={entry} key={entry.key} />
      ))}
    </Box>
  );
};

CicEditHistoryList.propTypes = {
  change: cicChangePropTypes.isRequired,
};

export default memo(CicEditHistoryList);
